import React, { useState } from 'react'

import Flex from '../flex'
import Button from '../button'
import Wrapper from '../wrapper'
import Logo from '../header/logo.png'
import * as API from '../../services/api'
import { Input, Textarea } from '../atoms'
import { VerifyCodeButton } from '../../molecules/demo/atoms'

import {
  Wrap,
  Part,
  Title,
  Link,
  Record,
  Footer as StyledFooter,
  Addr,
  Desc,
  MobileAddr,
} from './atoms'
import { color } from '../../style'
function Footer() {
  const [phone, setPhone] = useState('')
  const [detail, setDetail] = useState('')
  const [userName, setUserName] = useState('')
  const [rsVcToken, setRsVcToken] = useState('')
  const [verificationCode, setVerificationCode] = useState('')
  function handleClcik() {
    API.sendPhoneMessage(phone, 1).then((res) => {
      if (res.result) {
        setRsVcToken(res.data)
        alert('验证码发送成功')
      } else {
        alert('验证码发送失败')
      }
    })
  }
  function handleSubmit() {
    API.consult(userName, phone, detail, rsVcToken, verificationCode).then((res) => {
      if (res.result) {
        alert('提交成功')
      } else {
        alert('提交失败')
      }
    })
  }
  const disableSubmit = !(phone && detail && userName && rsVcToken && verificationCode)
  return (
    <StyledFooter>
      <Wrapper>
        <Wrap>
          <Part width='58%'>
            <Flex
              style={{ width: '30%' }}
              direction='column'
              halign='flex-start'
              valign='flex-start'
            >
              <img style={{ maxWidth: '100%', marginTop: 10 }} src={Logo} alt='' />
              <Desc>
                5G时代的到来加速了云游戏市场的不断壮大，我们希望提供多场景的云游戏解决方案与各大游戏内容厂商及平台达成紧密合作，快速布局，吸引更多玩家入局。
              </Desc>
            </Flex>
            <Flex
              style={{ width: '30%' }}
              direction='column'
              valign='flex-start'
              halign='flex-start'
            >
              <Title>产品</Title>
              <Link to='/iaas'>Iaas</Link>
              <Link to='/paas'>Paas</Link>
              <Title>快速入口</Title>
              {/* <Link to='/demo'>体验中心</Link> */}
              <Link to='/about'>关于我们</Link>
            </Flex>
            <Flex
              style={{ width: '30%' }}
              direction='column'
              valign='flex-start'
              halign='flex-start'
            >
              <Title>联系我们</Title>
              <span>黄先生</span>
              <span>13760300650（微信同号）</span>
              <span>肖先生</span>
              <span>18681593969（微信同号）</span>
              <MobileAddr>
                地址： 深圳市南山区商华路2号
                <br />
                阳光科创中心B座17层
              </MobileAddr>
            </Flex>
            <Addr>地址： 深圳市南山区商华路2号阳光科创中心B座17层</Addr>
          </Part>
          <Part width='42%'>
            <Title style={{ width: '100%' }}>服务咨询</Title>
            <Input
              placeholder='姓名'
              style={{ width: '37%', marginTop: 20 }}
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
            />
            <Input
              placeholder='手机号'
              style={{ width: '58%', marginLeft: '5%', marginTop: 20 }}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <Input
              placeholder='验证码'
              style={{ width: '58%', marginTop: 20 }}
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
            />
            <VerifyCodeButton
              style={{ width: '37%', marginTop: 20, height: 40 }}
              className='ripple'
              disabled={!phone}
              onClick={handleClcik}
            >
              获取验证码
            </VerifyCodeButton>
            <Textarea
              style={{ width: '100%', marginTop: 20 }}
              placeholder='如果您对产品想了解更多，请留下联系方式，我们会尽快联系您'
              value={detail}
              onChange={(e) => setDetail(e.target.value)}
            />
            <Button
              width={160}
              size='large'
              style={{ margin: '20px 0' }}
              onClick={handleSubmit}
              disabled={disableSubmit}
            >
              提交
            </Button>
          </Part>
        </Wrap>
        <Record>
          © 2020深圳市瑞云科技有限公司{' '}
          <a
            style={{ color: color.text, textDecoration: 'none' }}
            href='https://beian.miit.gov.cn/'
          >
            粤ICP备12028569号
          </a>
        </Record>
      </Wrapper>
    </StyledFooter>
  )
}

export default Footer
